import Button from './scripts';

import './styles/button.scss';
import './styles/button-wrap.scss';

export default Button;
